module.exports = __webpack_public_path__ + "img/certified_membership.c03f733b.png";